import PropTypes from "prop-types";
import React from "react";
import GenericModal from "./generic-modal.component";
import { ReactComponent as LogoutSvg } from "../../assets/vectors/logout.svg";

export default function LogoutModal({
  action,
  close,
  state,
}) {
  return (
    <GenericModal
      onClick={(event) => {
        if (event.target.classList.contains("close-modal")) {
          action();
        }
      }}
      modalState={state}
    >
      <div className="bg-white p-[54px] justify-center items-center text-center">
        <button
          onClick={() => close()}
          className="close-modal py-[5px] px-3 rounded-full border border-black absolute top-3 right-3"
        >
          X
        </button>
        <div className="flex flex-col gap-5 justify-center items-center">
         <LogoutSvg className="w-12 h-12 " />
          
            <h3 className="text-bold text-[20px] header-font">Logout</h3>
          
         
            <p className="font-light text-strong-[200] text-md mb-4">
            Are you sure you want to Logout?
            </p>
            <div className="flex w-full gap-6 justify-center items-center"> 

                <button className="hover:bg-primary border border-primary hover:text-white px-4 py-2 rounded-md transition-all"  onClick={() => close()} >Cancel</button>
                <button className="bg-red-400 hover:bg-red-600 text-white px-4 py-2 rounded-md transition-all"  onClick={() => action()}>Logout</button>
            </div>
        </div>
      </div>
    </GenericModal>
  );
}


LogoutModal.propTypes = {
  action: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  state: PropTypes.bool.isRequired,
};
